import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { getBarColor } from './survey-bar-colors';

export interface BarDataItem {
  label: string;
  value: number;
  count: number;
  answerValue: number;
}

interface SurveyResponseBarChartProps {
  data: BarDataItem[];
  selectedBarIndex?: number | null;
  onBarClick?: (index: number) => void;
}
export function SurveyResponseBarChart({ data, selectedBarIndex, onBarClick }: SurveyResponseBarChartProps) {
  return (
    <div className="h-[400px] w-full pt-4">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="horizontal" margin={{ top: 16 }} accessibilityLayer>
          <YAxis type="number" axisLine={false} tickLine={false} stroke="#fff" fontSize={14} domain={[0, 100]} />

          <XAxis dataKey="label" type="category" tickLine={false} fontSize={14} axisLine={false} stroke="#fff" />

          <CartesianGrid horizontal={false} strokeDasharray="3 3" strokeOpacity={0.2} stroke="#fff" />

          <Bar
            dataKey="value"
            radius={5}
            fill="#fff"
            isAnimationActive={false}
            onClick={(_data, index) => {
              if (data[index].count > 0) {
                onBarClick?.(index);
              }
            }}
          >
            {data.map((item, index) => (
              <Cell
                key={`cell-${index}`}
                fill={getBarColor(index)}
                radius={0}
                cursor={item.count > 0 ? 'pointer' : 'default'}
                stroke={selectedBarIndex === index ? '#fff' : 'none'}
                strokeWidth={selectedBarIndex === index ? 3 : 0}
              />
            ))}

            <LabelList
              dataKey="value"
              position="top"
              fontSize={14}
              fill="#fff"
              content={({ x, width, y, value, index }) => (
                <text
                  x={(x as number) + (width as number) / 2}
                  y={(y as number) - 5}
                  fill="#fff"
                  textAnchor="middle"
                  fontSize={14}
                >
                  {(value as number).toFixed(2)}% ({data[index as number].count})
                </text>
              )}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
